import { Button, Switch, Modal, Divider, Typography } from "antd";

const UpdateAdminConfigModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  adminConfig = {},
  handleConfigUpdate = () => {},
  updateAdminConfigState = () => {}
}) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="Modify Admin Config"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleConfigUpdate}>
          Update
        </Button>
      ]}
    >
      {Object.keys(adminConfig || {}).map((key) => {
        return (
          <div key={key}>
            <Divider orientation="left" style={{ margin: "12px 0" }}>
              {key?.toUpperCase()}
            </Divider>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {Object.keys(adminConfig[key] || {}).map((subKey) => {
                const isChecked = ((adminConfig || {})[key] || {})[subKey];
                return (
                  <div
                    key={subKey}
                    role="button"
                    tabIndex={0}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      transition: "background-color 0.2s"
                    }}
                    onClick={() => {
                      updateAdminConfigState(key, subKey, !isChecked);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        updateAdminConfigState(key, subKey, !isChecked);
                        e.preventDefault();
                      }
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.02)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <Typography.Text>{subKey}</Typography.Text>
                    <Switch
                      checked={isChecked}
                      onChange={(checked) => {
                        updateAdminConfigState(key, subKey, checked);
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </Modal>
  );
};
export default UpdateAdminConfigModal;
